export default class UpdateProposalRecordError extends Error {
}
